var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnTableCellDownloadGrayed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7804 9.69156C14.0733 9.39873 14.0731 8.92392 13.7804 8.63101C13.4875 8.33812 13.0128 8.33812 12.7199 8.63101L10.6496 10.7023V4.75015C10.6496 4.33594 10.3138 4.00015 9.89957 4.00015C9.48535 4.00015 9.14957 4.33594 9.14957 4.75015V10.7003L7.08023 8.63101C6.78734 8.33812 6.31258 8.33812 6.01969 8.63101C5.72709 8.92393 5.72689 9.39877 6.01969 9.69156L9.37027 13.0412C9.66318 13.3339 10.138 13.334 10.4308 13.0412L13.7804 9.69156Z",
    fill: "#D5D5D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 16H15",
    stroke: "#D5D5D5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnTableCellDownloadGrayed);
export default __webpack_public_path__ + "static/media/icn_table_cell_download_grayed.c64b1b1d2acb35dfc9686737e301c421.svg";
export { ForwardRef as ReactComponent };